// Pair of hooks for the login-time plan alert flow:
//
//   useReportPlanAlert(alert): used by the login/OAuth-exchange success
//     handler to push the alert from the auth response into context.
//
//   usePlanAlert(): used by <PlanAlertBanner /> to read the current alert.
//
// We could also read `useCurrentPlan().data.planAlert`, but pushing it from
// the login response avoids a redundant /plans/current round-trip right after
// authentication.

import { useEffect } from 'react';
import { usePlanContext } from './PlanProvider';
import type { PlanAlert } from '../types';

export function usePlanAlert(): PlanAlert | null {
  return usePlanContext().planAlert;
}

export function useReportPlanAlert(alert: PlanAlert | null | undefined): void {
  const { reportPlanAlert } = usePlanContext();
  useEffect(() => {
    reportPlanAlert(alert ?? null);
  }, [alert, reportPlanAlert]);
}
